(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feat-product-slider"] && !window.DesignMode) return;
  try {
    
$(document).ready(function(){
  $('.featured-product-slider').slick({
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-rebrand"] && !window.DesignMode) return;
  try {
    
$(document).ready(function(){
  $('.press-slider').slick({ 
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
const $window = $(window);
const $document = $(document);
const $body = $('body');
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;

  const $sliderCardsAlt = $('.js-slider-cards--alt .slider__slides');

  $sliderCardsAlt.on('init', function(event, slick, currentSlide, nextSlide) {
    let calc = ( (slick.currentSlide + 1) / (slick.slideCount - 1) ) * 100;

  
  });

  $sliderCardsAlt.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    let calc = ( (nextSlide + 1) / (slick.slideCount) ) * 100;

    });

      $sliderCardsAlt.each(function(){
            const $this = $(this);
                if ($window.width() > 1024) {
                if ($this.hasClass('slick-initialized')) {
                    $this.slick('unslick');
                }
            }
            else {
                if (!$this.hasClass('slick-initialized')) {
                    $this.slick({
                        variableWidth: true,
                        swipeToSlide: true,
                        arrows: false,
                        infinite: false,
                    });
                }
            }

      });

  

     $window.on('load resize orientationchange', function() {
        $sliderCardsAlt.each(function(){
            const $this = $(this);
                if ($window.width() > 1024) {
                if ($this.hasClass('slick-initialized')) {
                    $this.slick('unslick');
                }
            }
            else {
                if (!$this.hasClass('slick-initialized')) {
                    $this.slick({
                        variableWidth: true,
                        swipeToSlide: true,
                        arrows: false,
                        infinite: false,
                    });
                }
            }

      });


  });

            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["word-on-the-water"] && !window.DesignMode) return;
  try {
    
$(document).ready(function(){
  $('.testimonials-slider').slick({
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
});
});

  } catch(e) { console.error(e); }
})();
})();
